import React from 'react';
import { IconVideoAttachment } from 'jitsi/base/icons/svg';
import { AttachmentIcon } from './components/AttachmentIcon';
import { Container } from './components/Container';
import { Details } from './components/Details';
export const Video = ({ name, ...containerProps }) => {
    return (React.createElement(Container, { ...containerProps },
        React.createElement(AttachmentIcon, { icon: IconVideoAttachment, color: 'iisightBlue500' }),
        React.createElement(Details, { title: name, description: 'Video' })));
};
